import React, { useEffect, useState, useContext, useRef, useImperativeHandle } from "react";
import { Link, useLocation } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import api from "services/api";

import { Card } from "@mui/material";
import Grid from "@mui/material/Grid";

import Tooltip from "@mui/material/Tooltip";
import Pagination from "@mui/material/Pagination";

import SuiBadge from "components/SuiBadge";
import SuiTypography from "components/SuiTypography";
import SuiBadgeDot from "components/SuiBadgeDot";
import SuiBox from "components/SuiBox";
import SuiAvatar from "components/SuiAvatar";
import SuiSelect from "components/SuiSelect";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import { capitalCase } from "capital-case";
import { AccountContext } from "context/account";
import CategoryContext from "context/category-context";

import Prompt from "components/UpStyled/Prompt";
import toast from "react-hot-toast";
import moment from "moment";
import qs from "query-string";
import { useForm, Controller } from "react-hook-form";
import { DatePicker } from "antd";
import UTreeSelect from "components/UpStyled/UTreeSelect";

import { filterParser, sortParser } from "utils/helper";
import { stylesSortOptions, seasonOptions } from "utils/data";
import { handleUploadFiles } from "utils/imageHelper";

import StyleCard2 from "components/UpStyled/StyleCard2";

const ImportStyleModal2 = React.forwardRef(
  (
    {
      visible,
      handleClose,
      handleOk,
      isEdit = false,
      categoryTree = [],
      collection,
      handleRefresh = () => {},
      selectedItems = [],
    },
    ref
  ) => {
    const [data, setData] = useState({ hits: [], nbHits: 0, estimatedTotalHits: 0 });
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [searchStr, setSearchStr] = useState("");
    const [filterObj, setFilterObj] = useState({});
    const [collectionOptions, setCollectionOptions] = useState([]);
    const [selectedStyles, setSelectedStyles] = useState([]);
    const [checked, setChecked] = useState({});
    const [duplicateStyles, setDuplicateStyles] = useState([]);
    const [noDuplicateStyles, setNoDuplicateStyles] = useState([]);
    const [duplicateVisible, setDuplicateVisible] = useState(false);

    useImperativeHandle(
      ref,
      () => ({
        selectedStyles,
        setSelectedStyles,
      }),
      [selectedStyles]
    );

    const {
      register,
      handleSubmit,
      trigger,
      setValue,
      watch,
      getValues,
      reset,
      formState: { errors },
      control,
    } = useForm();

    useEffect(() => {
      if (visible) {
        retrieveCollections();
        let temp = {};
        for (let i = 0; i < selectedItems.length; i++) {
          temp[selectedItems[i]?.id] = true;
        }
        setSelectedStyles(selectedItems);
        setChecked(temp);
      }
      reset({ sort_by: stylesSortOptions[0] });
    }, [visible]);

    useEffect(() => {
      if (visible) {
        const offset = pageSize * (page - 1);
        const limit = pageSize;
        let filter = {};
        retrieveStyles(offset, limit, "", filter);
      }
    }, [visible]);

    const retrieveStyles = async (offset = 0, limit = pageSize, q = "", filter = {}) => {
      const payload = { offset, limit };
      if (q) {
        payload["q"] = q;
      }
      //let myFilter = { collection_id: null };
      //allow user import styles which is already in a collection
      //if already in a style, we will first duplicate it and then import the duplicated one to the collection
      let myFilter = {};
      if (collection?.id) {
        myFilter = { collection_id: { neq: collection.id } }; //filter out styles which already in the collection
      }
      if (Object.keys(filter).length > 0) {
        myFilter = { ...myFilter, ...filter };
      }

      //get sorting options from form values
      const sortOpt = getValues("sort_by");
      let sortStr = "";

      if (sortOpt && sortOpt.value) {
        sortStr = sortParser(sortOpt.value);
      }

      myFilter = {
        ...myFilter,
      };

      const newFilterStr = filterParser(myFilter);

      if (newFilterStr) {
        payload["filter"] = newFilterStr + " OR collection_id NOT EXISTS";
        setFilterObj(myFilter);
      }
      if (sortStr) {
        payload["sort"] = [sortStr];
      }
      try {
        //const { data } = await api.project.list({ owner_id: user.id });

        const { data } = await api.products.searchStyles(payload);

        setData(data ? data : { hits: [], nbHits: 0 });
      } catch (err) {
        console.log(err);
      }
    };

    const retrieveCollections = async () => {
      try {
        const { data } = await api.collections.list({ order: "-updated_at" });

        const collections = data["collections"] ? data["collections"] : [];
        const options = collections.map((x) => ({ label: x.title, value: x.id }));
        setCollectionOptions(options);
      } catch (err) {
        console.log(err);
      }
    };

    const handleApply = (data) => {
      const offset = pageSize * (page - 1);
      const limit = pageSize;
      setSearchStr(data["keywords"]);
      let myFilter = {};

      //category filter
      if (data["category"]) {
        myFilter["categories"] = data["category"];
      }
      //season filter
      if (data["season"] && data["season"]?.value) {
        myFilter["style_season"] = data["season"].value;
      }
      //collection filter
      if (data["collection"] && data["collection"]?.value) {
        myFilter["collection_id"] = data["collection"].value;
      }

      //year filter
      if (data["year"]) {
        let formatYearValue = moment(data["year"]).format("YYYY");
        myFilter["style_year"] = formatYearValue;
      }

      retrieveStyles(offset, limit, data["keywords"], myFilter);
    };

    const handleChangePage = (event, newPage) => {
      setPage(newPage);
      const offset = pageSize * (newPage - 1);
      const limit = pageSize;
      retrieveStyles(offset, limit, searchStr, filterObj);
    };

    const handleChangeRowsPerPage = (option) => {
      const newPageSize = parseInt(option.value, 10);
      setPageSize(newPageSize);
      setPage(1);
      const offset = 0;
      const limit = newPageSize;
      retrieveStyles(offset, limit, searchStr, filterObj);
    };

    const totalNumber = data.nbHits ? data.nbHits : data.estimatedTotalHits;
    const pageCount = parseInt(Math.ceil(totalNumber / pageSize), 10);
    const pageOptions = [];
    for (let i = 0; i < pageCount; i++) {
      pageOptions.push(i);
    }
    const entriesStart = pageSize * (page - 1) + 1;
    const entriesEnd = pageSize * page > totalNumber ? totalNumber : pageSize * page;

    const handleCheckStyle = (p) => {
      if (checked[p.id] == true) {
        // product was already in the list, then uncheck it
        const newSelectedStyles = selectedStyles.filter((x) => x.id != p.id);
        setSelectedStyles(newSelectedStyles);
      } else {
        setSelectedStyles([...selectedStyles, p]);
      }
      let temp = { ...checked };
      temp[p.id] = !checked[p.id];
      setChecked(temp);
    };

    const handleImportStyle = async () => {
      let currentIds = collection?.products.map((x) => x.id);
      let ids = selectedStyles.map((x) => x.id).filter((x) => !currentIds.includes(x));

      if (selectedStyles.length > 0 && ids.length == 0) {
        return toast.error(`Selected styles are already in the collection!`);
      }

      let filteredStyles = selectedStyles.filter((x) => !currentIds.includes(x)); //filter out styles which already in the collection
      const nonCollectionStyles = [];
      const collectionStyles = [];

      for (let i = 0; i < filteredStyles.length; i++) {
        if (filteredStyles[i].collection_id) {
          collectionStyles.push(filteredStyles[i]);
        } else {
          nonCollectionStyles.push(filteredStyles[i]);
        }
      }

      if (collectionStyles.length > 0) {
        setDuplicateStyles(collectionStyles);
        setNoDuplicateStyles(nonCollectionStyles);
        setDuplicateVisible(true);
      } else {
        if (ids.length > 0) {
          try {
            await api.collections.add(collection.id, ids);
            handleRefresh();
            handleClose(false);
          } catch (err) {
            toast.error(`Add style to collection:${collection["title"]} failed!`);
            console.log(err);
          }
        }
      }
    };

    const handleDuplicateAndImport = async () => {
      try {
        let currentIds = collection?.products.map((x) => x.id);
        //duplicate styles
        for (let i = 0; i < duplicateStyles.length; i++) {
          let payload = {
            title: "Copy of " + duplicateStyles[i]?.title,
            status: "design",
            description: duplicateStyles[i]?.description,
            options: [],
            collection_id: collection?.id,
            style: {
              ...duplicateStyles[i].style,
              style_number: "Copy of " + duplicateStyles[i]?.style?.style_number,
            },
            metadata: {
              ...duplicateStyles[i].metadata,
            },
          };
          if (duplicateStyles[i]?.ancestors) {
            payload["ancestors"] = [...duplicateStyles[i]?.ancestors, duplicateStyles[i].id];
          } else {
            payload["ancestors"] = [duplicateStyles[i].id];
          }

          if (payload?.style?.referenceFiles) {
            //should remove sample files when duplicate a style
            delete payload.style.referenceFiles;
          }

          await api.products.create(payload);
        }
        let ids = noDuplicateStyles.map((x) => x.id).filter((x) => !currentIds.includes(x));
        if (ids.length > 0) {
          await api.collections.add(collection.id, ids);
        }
        handleRefresh();
        handleClose(false);
      } catch (err) {
        toast.error(`Add style to collection:${collection["title"]} failed!`);
        console.log(err);
      }
    };

    return (
      <Dialog
        open={visible}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xl"
        fullWidth={true}
      >
        <DialogTitle id="alert-dialog-title">
          Import your styles{" "}
          <IconButton
            aria-label="close"
            onClick={() => handleClose()}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <SuiBox>
            <SuiBox component="form" pb={3} onSubmit={handleSubmit(handleApply)}>
              <SuiBox
                display="flex"
                alignItems="flex-start"
                justifyContent="space-between"
                sx={{ width: "100%" }}
              >
                <SuiBox display="flex" alignItems="center" sx={{ gap: 1.5, flexWrap: "wrap" }}>
                  <SuiTypography variant="button" color="dark" fontWeight="regular">
                    Filter by:
                  </SuiTypography>
                  <div style={{ width: 100 }}>
                    <Controller
                      name="year"
                      control={control}
                      render={({ field }) => (
                        <DatePicker
                          {...field}
                          picker="year"
                          placeholder="Year"
                          style={{
                            height: 40,
                            width: "100%",
                            borderRadius: "8px",
                            border: "1px solid #d2d6da",
                          }}
                          popupStyle={{
                            maxHeight: 400,

                            overflow: "auto",
                            zIndex: 9999,
                          }}
                        />
                      )}
                    />
                  </div>
                  <div style={{ width: 140 }}>
                    <Controller
                      name="collection"
                      control={control}
                      render={({ field }) => (
                        <SuiSelect
                          {...field}
                          options={collectionOptions}
                          placeholder="Collection"
                          backspaceRemovesValue
                          isClearable
                        />
                      )}
                    />
                  </div>
                  <div style={{ width: 140 }}>
                    <Controller
                      name="season"
                      control={control}
                      render={({ field }) => (
                        <SuiSelect
                          {...field}
                          options={seasonOptions}
                          placeholder="Season"
                          backspaceRemovesValue
                          isClearable
                        />
                      )}
                    />
                  </div>
                  <div style={{ minWidth: 210 }}>
                    <Controller
                      control={control}
                      name="category"
                      render={({ field: { onChange, onBlur, value, name, ref } }) => (
                        <UTreeSelect
                          tree={categoryTree}
                          fieldNames={{ label: "label", value: "id", children: "children" }}
                          onChange={(e) => {
                            onChange(e);
                          }}
                          allowClear={true}
                          value={value}
                          placeholder="Category"
                        />
                      )}
                    />
                  </div>
                  <div style={{ width: 145 }}>
                    <Controller
                      name="sort_by"
                      control={control}
                      render={({ field }) => (
                        <SuiSelect
                          {...field}
                          options={stylesSortOptions}
                          placeholder="Sort By"
                          backspaceRemovesValue
                        />
                      )}
                    />
                  </div>
                  <SuiBox>
                    <SuiInput placeholder="Keywords" type="text" {...register("keywords")} />
                  </SuiBox>
                  <div>
                    <SuiButton variant="gradient" color="dark" type="submit">
                      Apply
                    </SuiButton>
                  </div>
                </SuiBox>
              </SuiBox>
              {/* <SuiBox>
                <SuiTypography
                  variant="body2"
                  fontWeight="regular"
                  color="text"
                  sx={{ lineHeight: 1.2, my: 1 }}
                >
                  <SuiBox style={{ fontWeight: "bold" }} color="dark" component="span">
                    Note:
                  </SuiBox>{" "}
                  You can only import styles that are not included in any collections. If you want
                  to import a style from another collection, please go to the style, use the
                  “Duplicate“ button, and then select this current collection in the pop-up window
                  to copy the style to this collection.
                </SuiTypography>
              </SuiBox> */}
            </SuiBox>

            <SuiBox
              display="flex"
              justifyContent="flex-start"
              sx={{ flexWrap: "wrap", minHeight: 200 }}
            >
              {data.hits.map((u, index) => {
                return (
                  <SuiBox key={index}>
                    <StyleCard2
                      product={u}
                      size="md"
                      isSelected={checked[u.id] ? true : false}
                      handleSelectStyle={(e) => handleCheckStyle(u)}
                    />
                  </SuiBox>
                );
              })}
            </SuiBox>
            <SuiBox
              display="flex"
              flexDirection={{ xs: "column", sm: "row" }}
              justifyContent="space-between"
              alignItems={{ xs: "flex-start", sm: "center" }}
              p={3}
            >
              <SuiBox display="flex" alignItems="center">
                <SuiBox mb={{ xs: 3, sm: 0 }}>
                  <SuiTypography variant="button" color="secondary" fontWeight="regular">
                    Showing {entriesStart} to {entriesEnd} of {totalNumber} entries
                  </SuiTypography>
                </SuiBox>

                <SuiBox display="flex" alignItems="center" gap={1}>
                  <SuiSelect
                    defaultValue={{ value: pageSize, label: pageSize }}
                    options={[10, 20, 50].map((entry) => ({ value: entry, label: entry }))}
                    onChange={handleChangeRowsPerPage}
                    size="small"
                  />

                  <SuiTypography variant="caption" color="secondary">
                    entries per page
                  </SuiTypography>
                </SuiBox>
              </SuiBox>
              <Pagination
                variant={"outlined"}
                color={"info"}
                count={pageOptions.length}
                defaultPage={page}
                onChange={handleChangePage}
              />
            </SuiBox>
          </SuiBox>
        </DialogContent>
        <DialogActions>
          <SuiButton variant="gradient" size="medium" onClick={handleClose} color="light">
            Cancel
          </SuiButton>
          <SuiButton
            size="medium"
            variant="gradient"
            color="dark"
            onClick={handleOk ? () => handleOk(selectedStyles) : handleImportStyle}
          >
            Import
          </SuiButton>
        </DialogActions>
        {collection?.id && duplicateVisible && duplicateStyles ? (
          <Prompt
            heading="Duplicate Styles"
            text={
              <div>
                Your Style(s):{" "}
                <strong>
                  {" "}
                  <i>{duplicateStyles.map((x) => x.title).join(",")}</i>
                </strong>{" "}
                already belongs to a collection. Do you want to duplicate and import to{" "}
                {collection.title}?
              </div>
            }
            visible={duplicateVisible}
            okText="Duplicate & Import"
            okColor="dark"
            handleOk={handleDuplicateAndImport}
            handleClose={() => setDuplicateVisible(false)}
          />
        ) : null}
      </Dialog>
    );
  }
);

export default ImportStyleModal2;
